export const selectProductWallPosts = state => state.productWall.posts
